<template>
  <search
    :create-route="createRoute"
    :can-create="canCreate"
    :search-filter="searchFilter"
    :search-route="searchRoute"
    :page-title="pageTitle"
    :saved-filters="savedFilters"
    :excluded-fields="['account.id', 'users.id']"
    :model-name="modelName"
    :is-subscribed="isSubscribed"
  >
    <template
      slot="results"
      slot-scope="{ items }"
    >
      <ul class="mt-4 bg-white">
        <li
            v-for="(project, index) in items"
            :key="project.id"
            :class="{
                'border-t border-gray-200': index > 0
            }"
        >
          <a
              :href="route('projects.show', { project: project.id })"
              class="block hover:bg-gray-50"
          >
            <div class="flex items-start px-4 py-4 sm:px-6">
                <div class="flex-1 min-w-0 sm:flex sm:items-center sm:justify-between">
                  <div>
                    <div class="flex font-medium text-blue-900 truncate text-md">
                      <p>
                        {{ project.name }}
                      </p>
                      <p
                        v-if="project.status"
                        class="inline-flex px-2 ml-4 space-x-2 text-xs leading-5 text-gray-600 rounded-full bg-gray-50"
                      >
                        <span>Status:</span> <span class="font-semibold text-gray-900">{{ project.status }}</span>
                      </p>
                    </div>
                    <div class="flex mt-2">
                      <div class="flex items-center text-sm text-gray-500">
                        <p>
                        <time :datetime="project.created_at">
                          {{ project.created_at }}
                        </time>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="flex-row ml-8 space-y-4">
                  <p class="flex justify-end">
                    <span class="inline-flex px-2 text-xs font-semibold leading-5 text-green-800 bg-green-100 rounded-full">{{ project.type }}</span>
                  </p>
                  <div class="flex overflow-hidden">
                    <img
                      v-for="(user, userIndex) in project.users"
                      :key="user.id"
                      class="inline-block w-6 h-6 rounded-full ring-2 ring-white"
                      :class="{
                        '-ml-1': userIndex > 0,
                      }"
                      :src="user.extra_small_avatar"
                      :alt="user.name">
                  </div>
                </div>
            </div>
          </a>
        </li>
      </ul>
    </template>
  </search>
</template>

<script>

export default {
  props: {
    createRoute: {
      type: String,
      required: false,
      default: null
    },
    canCreate: {
      type: Boolean,
      default: false,
    },
    pageTitle: {
      type: String,
      required: true,
    },
    searchRoute: {
      type: String,
      required: true,
    },
    searchFilter: {
      type: [Array, Object],
      required: false,
    },
    modelName: {
      type: String,
      required: false,
    },
    savedFilters: {
      type: [Array, Object],
      required: false,
    },
    isSubscribed: {
        type: Boolean,
        required: false,
    }
  },
};
</script>
